import { filterByGameLocationsAndResults } from '@/utils/playsFiltering';
import { getTeamTableData } from '@/utils/teamTableData';
import { getLocalVsVisitorData } from '@/data/generators/localVsVisitorData';
import { defensiveValues } from '@/data/statisticsLocalVsVisitorValues';
import { getSoccerGoalData } from '@/data/generators/soccerGoalData';
import { getChalkboardPlayList, getChalkboardGames } from '@/data/generators/soccerChalkboardData';
import teamStatsPlayIndexes from '@/data/team/teamStatsPlayIndexes';
import teamGoalPlayIndexes from '@/data/team/teamGoalPlayIndexes';
import { defensive } from '@/data/team/featured-players-categories';

const state = {
  indexes: teamStatsPlayIndexes(),
  basePlaysStack: [],
  goalPlaysStack: [],
  categories: [
    { name: 'Goles recibidos', color: '#4A90E2', points: [1, 2, 3], categories: [12] },
    { name: 'Tiros a gol recibidos', color: '#F2E82E', points: [1, 2, 3], categories: [10], negative: true },
    { name: 'Tiros a gol recibidos (portería)', color: '#8E17EF', points: [1, 2, 3], categories: [30] },
    { name: 'Centros totales recibidos', color: '#FF8000', points: [2, 3], categories: [20] },
    { name: 'Centros acertados por el rival', color: '#068A8E', points: [2, 3], categories: [30] },
    { name: 'Balones recuperados (en disputa)', color: '#FB04C7', points: [1, 2], categories: [40] },
    { name: 'Balones recuperados (sin disputa)', color: '#606060', points: [1, 2], categories: [50] },
    { name: 'Fuera de lugar provocados', color: 'green', points: [1, 2], categories: [11] },
    { name: '1 vs 1 exitosos defensivos', color: 'cyan', points: [2], categories: [4] },
    { name: '1 vs 1 no exitosos defensivos', color: 'cyan', points: [2], categories: [4] },
    { name: 'Balones ganados en área propia', color: 'cyan', points: [2], categories: [4] },
    { name: 'Juego aéreo resto del campo', color: 'cyan', points: [2], categories: [4] },
    { name: 'Barridas', color: 'cyan', points: [2], categories: [4] },
    { name: 'Rechaces', color: 'cyan', points: [2], categories: [4] },
  ],
  featuredPlayersCategories: defensive,
};

const mutations = {
  updatePlaysStack(state, playsStack) {
    state.basePlaysStack = playsStack;
  },
  updateGoalPlaysStack(state, playsStack) {
    state.goalPlaysStack = playsStack;
  },
};

const getters = {
  getPlaysStack(state, getters, rootState, rootGetters) {
    const sections = rootGetters['filterGeneral/getSections'];
    return getters.filteredPlaysStack.filter(play => sections.includes(play[state.indexes.section]));
  },
  filteredPlaysStack(state, getters, rootState, rootGetters) {
    return filterByGameLocationsAndResults(
      state.basePlaysStack,
      rootGetters['filterGeneral/getPlayingAs'],
      rootGetters['filterGeneral/getResults'],
      rootGetters['filterGeneral/getSelectedGamesIds'],
      teamStatsPlayIndexes(),
      rootGetters['teamsGeneral/team'].team_id,
    );
  },
  tableData(state, getters, rootState, rootGetters) {
    //Stadistic_id helps to select if data current average is divided by games played or season teams
    const STADISTIC_ID = rootGetters['filterGeneral/getStadisticId'];
    const totalSeasonGamesOrTeams =
      STADISTIC_ID === 0
        ? rootGetters['gamesGeneral/gamesPlayed']
        : rootGetters['teamsGeneral/teamsForAnalysis'].length;

    return getTeamTableData(
      3,
      getters.filteredPlaysStack,
      rootGetters['leagueGeneral/filteredPlaysStack'],
      rootGetters['filterGeneral/getSections'],
      totalSeasonGamesOrTeams,
      rootGetters['teamsGeneral/team'].team_id,
    );
  },
  localVsVisitorData(state, getters, rootState, rootGetters) {
    return getLocalVsVisitorData(
      getters.filteredPlaysStack,
      rootGetters['filterGeneral/getSections'],
      defensiveValues,
      teamStatsPlayIndexes(),
      rootGetters['teamsGeneral/team'].team_id,
    );
  },
  chalkboardPlays(state, getters, rootState, rootGetters) {
    return getChalkboardPlayList(
      getters.filteredPlaysStack,
      rootGetters['filterGeneral/getSections'],
      teamStatsPlayIndexes(),
    );
  },
  chalkboardGames(state, getters, rootState, rootGetters) {
    return getChalkboardGames(
      rootGetters['teamsGeneral/teamsForAnalysis'],
      rootGetters['gamesGeneral/seasonGamesPlayed'],
    );
  },
  goalPlays(state, getters, rootState, rootGetters) {
    return getSoccerGoalData(
      state.goalPlaysStack,
      rootGetters['filterGeneral/getPlayingAs'],

      rootGetters['filterGeneral/getResults'],
      rootGetters['filterGeneral/getSections'],
      rootGetters['filterGeneral/getSelectedGamesIds'],
      teamGoalPlayIndexes(),
    );
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
